<template>
  <div class="container notes-list-container px-0 px-md-3">
    <alert v-if="loading" class="light-shadow" />
    <div v-if="!loading && !newOnly">
      <div class="d-flex flex-wrap justify-content-end align-items-center mb-3">
        <div
          class="
            d-flex
            align-items-center
            mr-sm-3
            col-12 col-sm-auto
            mb-3 mb-sm-0
            px-0 px-sm-3
            select-100
          "
          v-if="false"
        >
          <label class="col-form-label col-auto p-0 pr-3 m-0"> Code: </label>
          <select-control
            v-model="selectedICDCode"
            :options="codeOptions"
            labelClass="d-none"
            wrapClass="align-items-center mb-0"
            @input="getNotes()"
            :disabled="loading"
          ></select-control>
        </div>
        <div
          class="
            d-flex
            align-items-center
            mr-sm-3
            col-12 col-sm-auto
            mb-3 mb-sm-0
            px-0 px-sm-3
            select-100
          "
        >
          <label class="col-form-label col-auto p-0 pr-3 m-0"> Status: </label>
          <select-control
            v-model="selectedStatus"
            :options="statusOptions"
            labelClass="d-none"
            wrapClass="align-items-center mb-0"
            @input="getNotes()"
            :disabled="loading"
          ></select-control>
        </div>
        <button
          class="btn btn-black pointer-cursor"
          @click="addNewNote()"
          v-if="!user.isPatient"
        >
          Add New Note
        </button>
      </div>
    </div>
    <div v-if="!loading && notes.length > 0">
      <div
        v-for="note in notes"
        :key="note.id"
        class="card light-shadow note-card"
      >
        <div
          class="note-container radius-36"
          :class="externalId == note.id ? 'focused-note' : ''"
          :ref="'container-report-' + note.id"
        >
          <i
            class="fa-solid fa-lg fa-user-check text-deep-success approved-icon"
            title="Certified"
            v-if="note.approved"
            ><span class="pl-2">Certified</span></i
          >
          <div
            class="text-right mt-1"
            style="margin-left: 150px"
            v-if="!note.isNew"
          >
            <button
              class="btn btn-sm btn-link p-0 text-black copy-btn"
              @click="copyText(note)"
            >
              Copy <i class="fa-regular fa-copy"></i>
            </button>
            <span class="px-2" v-if="hasPermissionToEdit(note)">|</span>
            <button
              class="btn btn-sm btn-link p-0 text-black copy-btn"
              @click="editNote(note)"
              :disabled="
                note.editing ||
                note.approving ||
                note.deleting ||
                note.togglingAccess
              "
              v-if="hasPermissionToEdit(note)"
            >
              Edit <i class="fa-regular fa-edit ml-1"></i>
            </button>
            <span class="px-2" v-if="hasPermissionToDelete(note)">|</span>
            <button
              class="btn btn-sm btn-link p-0 text-black copy-btn"
              v-if="hasPermissionToDelete(note)"
              :disabled="note.deleting || note.approving || note.togglingAccess"
              @click="deleteNote(note)"
            >
              Delete <i class="fa fa-trash ml-1" v-if="!note.deleting"></i>
              <i
                class="fa fa-spin fa-circle-notch ml-1"
                v-if="note.deleting"
              ></i>
            </button>

            <span class="px-2" v-if="user.isAdmin || user.isManagingAdmin"
              >|</span
            >
            <button
              class="btn btn-sm btn-link p-0 text-black copy-btn"
              v-if="user.isAdmin || user.isManagingAdmin"
              :disabled="note.deleting || note.approving || note.togglingAccess"
              @click="toggleNoteAccess(note)"
            >
              {{ note.access == 0 ? "All" : "Admins Only" }}
              <i
                class="fa ml-1"
                :class="note.access == 0 ? 'fa-unlock' : 'fa-lock'"
                v-if="!note.togglingAccess"
              ></i>
              <i
                class="fa fa-spin fa-circle-notch ml-1"
                v-if="note.togglingAccess"
              ></i>
            </button>
          </div>
          <div
            class="
              d-flex
              flex-wrap
              justify-content-sm-between
              align-items-sm-center
              flex-column flex-sm-row
            "
            v-if="note.isNew"
          >
            <badge
              class="badge-outline-deep-success mt-3"
              style="font-size: 1em"
              >New Engagement Note</badge
            >

            <select-control
              v-model="note.access"
              :options="accessOptions"
              type="horizontal"
              wrapClass="align-items-center mb-0 mt-3"
              labelClass="col-4 col-sm-auto pr-0"
              >Access</select-control
            >
          </div>
          <div v-if="note.isNew && notesInfo.enabled">
            <audio-recorder
              ref="audioRecorderComponent"
              @scribeStarted="updateScribeStatus()"
              :meetingId="meeting?.id"
              :demoLink="scribeDemoLink"
              :disabled="note.saving"
              @recordingComplete="completeAIScribe"
            ></audio-recorder>
          </div>
          <div
            class="
              d-flex
              flex-wrap flex-column flex-md-row
              justify-content-between
              border-bottom
              pt-3
              pb-2
              mb-3
            "
            v-if="!note.isNew"
          >
            <p class="h2 mb-3 mb-md-0">{{ note.title }}</p>
            <div class="text-left text-md-right">
              <p v-if="note.reporter" class="mb-0">
                Added by
                <span class="font-weight-bold mr-2">{{
                  note.reporter.name
                }}</span>
                <span class="small"> {{ getDate(note.created_at) }}</span>
              </p>
              <p v-if="note.editor" class="mb-0">
                Updated by
                <span class="font-weight-bold mr-2">{{
                  note.editor.name
                }}</span>
                <span class="small">
                  {{ note.edited_at ? getDate(note.edited_at) : "(N/A)" }}</span
                >
              </p>
              <p v-if="note.approver" class="mb-0">
                {{ note.approved ? "Certified" : "Uncertified" }} by
                <span class="font-weight-bold">{{ note.approver.name }}</span>
                <span class="small"> {{ getDate(note.approved_at) }}</span>
              </p>
            </div>
          </div>
          <div v-if="note.encounter_id" class="d-flex justify-content-end">
            <button
              class="btn btn-e27c1d mt-3 mt-sm-0 mr-3 mr-sm-0"
              @click="openEncounterModal(note)"
            >
              <b>AI Note </b> is ready for review
              <i class="fa fa-lg fa-info-circle ml-2"></i>
            </button>
          </div>
          <div class="mb-4 border-bottom pb-2" v-if="!note.isNew">
            <div class="mb-1">
              <span class="font-weight-bold pr-2">Event:</span>
              <span v-if="!note.appointment && !note.group_session">N/A</span>
              <span v-if="note.appointment">{{
                allPatientAptsOptions.filter(
                  (item) => item.value == `apt-${note.appointment.id}`
                )[0]?.label
              }}</span>
              <span v-if="note.group_session">{{
                formatGroupSessionLabel(note.group_session)
              }}</span>
            </div>
            <div
              class="note-services-codes d-flex align-items-center"
              v-if="false"
            >
              <span class="font-weight-bold pr-2">ICD Codes:</span>
              <span v-if="!note.service_codes?.length">N/A</span>
              <badge
                v-for="service in note.service_codes"
                :key="service.code"
                class="mr-2 badge-deep-success"
                >{{ service.code }}</badge
              >
            </div>
          </div>
          <div
            v-html="getDocumentText(note.report)"
            :ref="`report-${note.id}`"
            class="report-outer-container"
          ></div>

          <div
            class="narrative-report border-top mt-4 pt-2"
            v-if="note.narrativeReport"
          >
            <div class="text-right copy-container">
              <button
                class="btn btn-sm btn-link p-0 text-black copy-btn"
                @click="copyText(note, 'narrative')"
              >
                Copy <i class="fa-regular fa-copy"></i>
              </button>
              <span class="px-2" v-if="hasPermissionToEdit(note)">|</span>
              <button
                class="btn btn-sm btn-link p-0 text-black copy-btn"
                @click="editNote(note, false, 'narrative')"
                :disabled="note.editing"
                v-if="hasPermissionToEdit(note)"
              >
                Edit <i class="fa-regular fa-edit ml-1"></i>
              </button>
            </div>
            <div
              v-html="note.narrativeReport"
              :ref="'narrative-' + note.id"
            ></div>
          </div>
          <div class="soap-report border-top mt-4 pt-2" v-if="note.soapReport">
            <div class="text-right copy-container">
              <button
                class="btn btn-sm btn-link p-0 text-black copy-btn"
                @click="copyText(note, 'soap')"
              >
                Copy <i class="fa-regular fa-copy"></i>
              </button>
              <span class="px-2" v-if="hasPermissionToEdit(note)">|</span>
              <button
                class="btn btn-sm btn-link p-0 text-black copy-btn"
                @click="editNote(note, false, 'soap')"
                :disabled="note.editing"
                v-if="hasPermissionToEdit(note)"
              >
                Edit <i class="fa-regular fa-edit ml-1"></i>
              </button>
            </div>
            <div v-html="note.soapReport" :ref="'soap-' + note.id"></div>
          </div>
          <div
            class="report-summary pt-4 border-top mt-4"
            v-if="note.editing || note.isNew"
            :ref="'edit-' + note.id"
          >
            <div
              class="
                d-flex
                flex-wrap flex-column flex-md-row
                justify-content-between
              "
            >
              <div class="col-12 col-md-6 px-0 position-relative mt-md-2">
                <a
                  v-if="getAdjustTimeStatus(note).visible"
                  href="#"
                  class="small adjust-time-link"
                  :class="
                    getAdjustTimeStatus(note).allowed
                      ? 'text-primary'
                      : 'text-muted'
                  "
                  :style="
                    !getAdjustTimeStatus(note).allowed
                      ? 'cursor: not-allowed; opacity: 0.7;'
                      : ''
                  "
                  v-tooltip.top="
                    !getAdjustTimeStatus(note).allowed
                      ? getAdjustTimeStatus(note).reason
                      : ''
                  "
                  @click.prevent="
                    getAdjustTimeStatus(note).allowed &&
                      openAdjustTimeModal(note)
                  "
                >
                  <i class="fas fa-clock mr-1"></i>Adjust Time
                </a>
                <select-control
                  type="horizontal"
                  class="px-0 appointment-select-container"
                  wrapClass="align-items-md-center mx-md-0 flex-column flex-md-row"
                  labelClass="col-12 col-sm-auto pr-0 pl-3 pl-md-0"
                  v-model="note.event_id"
                  :options="patientAptsOptions"
                  :disabled="
                    gettingMeetingInfo ||
                    isGettingAPts ||
                    isGettingGroupSessions ||
                    (note.group_session_id &&
                      publicSettings?.GROUP_SESSIONS_ENABLED === false)
                  "
                  inputClass="light-shadow"
                  @input="onEventSelected(note, note.event_id)"
                  >Event<i
                    class="fas fa-spinner fa-spin ml-1"
                    v-if="
                      isGettingAPts ||
                      isGettingGroupSessions ||
                      gettingMeetingInfo
                    "
                  ></i
                ></select-control>
              </div>
              <div
                class="
                  form-group
                  row
                  d-flex
                  align-items-md-center
                  col-12
                  flex-column
                  col-md-6
                  flex-md-row
                  px-0
                  pl-md-3
                  mx-0
                  flex-nowrap
                  icd-select-container
                "
                v-if="false && !note.group_session_id"
              >
                <label class="col-auto p-0 m-0">ICD Codes</label>
                <multiselect
                  class="no-labels pl-md-3 app-select"
                  v-model="note.selectedCodes"
                  :options="ohipCodes"
                  :searchable="true"
                  :close-on-select="false"
                  :multiple="true"
                  :clear-on-select="false"
                  :allow-empty="true"
                  :show-labels="false"
                  placeholder="Search for ICD Code"
                  label="code"
                  track-by="id"
                  @update:modelValue="$forceUpdate()"
                  :customLabel="
                    (option) => option.code + ' - ' + option.description
                  "
                  :disabled="ohipCodesLoading"
                  :loading="ohipCodesLoading"
                >
                  <template #selection="props">
                    <span
                      class="multiselect__tag"
                      v-for="(option, index) in props.values"
                      :key="index"
                    >
                      <span>{{ option.code }}</span>
                      <i
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click="props.remove(option)"
                      ></i>
                    </span>
                  </template>

                  <template #singleLabel="props">
                    <span class="option__desc"
                      ><span class="option__title">{{
                        props.option.code
                      }}</span></span
                    ></template
                  >
                  <template #option="props">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <div class="font-weight-bold select-label">
                          {{ props.option.code }}
                        </div>
                        <div class="small select-sublabel mt-1">
                          Description: {{ props.option.description || "-" }}
                        </div>
                      </div>
                      <div
                        class="small font-weight-bold select-sublabel"
                        style="opacity: 0.9"
                      >
                        ({{ props.option.measure }})
                      </div>
                    </div>
                  </template>

                  <template #noResult>
                    <div class="no-result">Oops! No ICD Codes found.</div>
                  </template>
                </multiselect>
              </div>
            </div>
            <small
              v-if="
                note.group_session_id &&
                publicSettings?.GROUP_SESSIONS_ENABLED === false
              "
              class="text-muted mt-1 pl-3 pl-md-0"
            >
              Group Sessions feature is currently disabled
            </small>
            <input-control
              type="horizontal"
              v-model="note.editingTitle"
              wrapClass="mt-3"
              labelClass="d-none"
              placeholder="Title"
              >Title</input-control
            >
            <ckeditor
              :editor="editor"
              v-model="note.editingText"
              :config="editorConfig"
            >
            </ckeditor>
            <div class="d-flex justify-content-center pt-4">
              <button
                v-if="!note.isNew || !scribeStarted"
                class="btn btn-deep-success"
                :disabled="note.saving"
                @click="!note.saving && saveNote(note, true)"
              >
                <span
                  v-if="note.saving && note.approving"
                  class="fa fa-spin fa-circle-notch mr-2"
                ></span>
                {{ note.isNew ? "Add" : "Save" }} & Certify
              </button>
              <button
                v-if="!note.approved && (!note.isNew || !scribeStarted)"
                class="btn btn-black ml-3"
                :disabled="note.saving"
                @click="!note.saving && saveNote(note)"
              >
                <span
                  v-if="note.saving && !note.approving"
                  class="fa fa-spin fa-circle-notch mr-2"
                ></span>
                {{ note.isNew ? "Add" : "Save" }}
              </button>
              <button
                class="btn btn-danger ml-3"
                :disabled="note.saving"
                @click="!note.saving && editNote(note, true)"
              >
                <span
                  v-if="note.saving"
                  class="fa fa-spin fa-circle-notch mr-2"
                ></span>
                {{
                  note.saving
                    ? "Saving..."
                    : scribeUploading
                    ? "Close"
                    : "Cancel"
                }}
              </button>
            </div>
          </div>
          <div
            class="d-flex flex-wrap mt-3"
            v-if="note.attachments && note.attachments.length"
          >
            <div
              class="firsthx-image-thumb"
              v-for="img in note.attachments"
              :key="'intake-img-' + img.id"
            >
              <img
                :src="img.url"
                alt="Generated visual"
                @click="openIntakeFormImage(img)"
              />
              <button
                v-if="!user.isPatient && hasPermissionToDelete(note)"
                class="firsthx-image-delete-btn"
                title="Delete"
                @click.stop="deleteIntakeFormImage(note, img)"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div
            class="accordion border rounded mt-3 bg-white"
            :id="`intake-form-id-${note.id}`"
            v-if="note.intake_form"
          >
            <div class="card-header pl-2" :id="`heading-id-${note.id}`">
              <h2 class="my-0">
                <button
                  class="
                    btn btn-link
                    text-uppercase text-left
                    w-100
                    font-weight-bold
                    position-relative
                    expand-header
                    collapsed
                  "
                  type="button"
                  data-toggle="collapse"
                  :data-target="`#collapse-id-${note.id}`"
                  :aria-controls="`collapse-id-${note.id}`"
                >
                  {{ note.isNew ? "Last " : "" }}Intake Form
                  <i class="fa fa-chevron-up expand-icon"></i>
                </button>
              </h2>
            </div>
            <div
              :id="`collapse-id-${note.id}`"
              class="collapse"
              :aria-labelledby="`heading-id-${note.id}`"
              :data-parent="`#intake-form-id-${note.id}`"
            >
              <div class="card-body pt-2">
                <div
                  class="section-box border rounded mb-5"
                  v-if="note.clientInfo.name"
                >
                  <h2 class="title border-bottom py-4 rounded-top px-2">
                    {{ $filters.customerLabel("singular", true) }} Information
                  </h2>
                  <div class="content px-3 pb-2">
                    <div class="item d-flex">
                      <div class="key">ID:</div>
                      <div class="value">
                        {{ note.clientInfo["patient_id"] }}
                      </div>
                    </div>
                    <div class="item d-flex">
                      <div class="key">Name:</div>
                      <div class="value">{{ note.clientInfo["name"] }}</div>
                    </div>
                    <div class="item d-flex">
                      <div class="key">Gender:</div>
                      <div class="value">{{ note.clientInfo["sex"] }}</div>
                    </div>
                    <div class="item d-flex">
                      <div class="key">Date Of Birth:</div>
                      <div class="value">{{ note.clientInfo["dob"] }}</div>
                    </div>
                    <div class="item d-flex">
                      <div class="key">Age:</div>
                      <div class="value">{{ note.clientInfo["age"] }}</div>
                    </div>
                    <div
                      class="item d-flex"
                      v-if="note.clientInfo['diagnosis']"
                    >
                      <div class="key">Diagnosis:</div>
                      <div class="value">
                        {{ note.clientInfo["diagnosis"] }}
                      </div>
                    </div>
                    <div
                      class="item d-flex"
                      v-if="note.clientInfo['assessment']"
                    >
                      <div class="key">Assessment:</div>
                      <div class="value">
                        {{ note.clientInfo["assessment"] }}
                      </div>
                    </div>
                    <div
                      class="item d-flex"
                      v-if="note.clientInfo['treatment']"
                    >
                      <div class="key">Treatment:</div>
                      <div class="value">
                        {{ note.clientInfo["treatment"] }}
                      </div>
                    </div>
                    <div
                      class="item d-flex"
                      v-if="note.clientInfo['intervention']"
                    >
                      <div class="key">Intervention:</div>
                      <div class="value">
                        {{ note.clientInfo["intervention"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <tree-node :node="parseIntake(note.intake_form)"></tree-node>
              </div>
            </div>
          </div>

          <div
            class="footer-actions border-top pt-3 mt-5 text-center"
            v-if="
              !note.isNew &&
              !note.editing &&
              (!note.narrativeReport || !note.soapReport || !note.approver)
            "
          >
            <button
              class="
                btn btn-deep-success
                mr-md-4
                mb-2 mb-lg-0
                col-10 col-md-auto
              "
              v-if="hasPermissionToApprove(note)"
              @click="approveNote(note)"
              :disabled="note.approving"
            >
              <span
                v-if="note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Certify
            </button>

            <button
              class="btn btn-deep-red mr-md-4 mb-2 mb-lg-0 col-10 col-md-auto"
              v-if="hasPermissionToReject(note)"
              @click="approveNote(note)"
              :disabled="note.approving"
            >
              <span
                v-if="note.approving"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Uncertify
            </button>
            <button
              class="btn btn-secondary mr-md-4 mb-2 mb-lg-0 col-10 col-md-auto"
              v-if="!note.narrativeReport && !user.isPatient"
              @click="generateSummary(note, 'narrative')"
              :disabled="note.narrativeLoading"
            >
              <span
                v-if="note.narrativeLoading && !user.isPatient"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Generate Narrative Summary
            </button>
            <button
              class="btn btn-secondary mr-md-4 mb-2 mb-lg-0 col-10 col-md-auto"
              v-if="!note.soapReport && !user.isPatient"
              @click="generateSummary(note, 'soap')"
              :disabled="note.soapLoading"
            >
              <span
                v-if="note.soapLoading && !user.isPatient"
                class="fa fa-spin fa-circle-notch mr-2"
              ></span>
              Generate SOAP Note Format
            </button>
            <button
              v-if="canShowPrescription(note)"
              class="btn btn-black mr-md-4 mb-2 mb-lg-0 col-10 col-md-auto"
              @click="openPrescriptionModal(note)"
            >
              {{ note.prescription_id ? "Show" : "Add" }} Prescription
            </button>
          </div>
        </div>
      </div>
    </div>
    <alert
      class="light-shadow"
      v-if="!loading && !notes.length"
      :hideLoader="true"
      >No engagement notes added yet.</alert
    >

    <file-viewer
      v-model="showIntakeImageViewerModal"
      :name="selectedIntakeImage.name"
      :type="selectedIntakeImage.type"
      :link="selectedIntakeImage.link"
    />

    <modal
      class="prescription-modal"
      name="prescription-modal"
      transition="pop-out"
      v-model="showPrescriptionModal"
    >
      <div class="position-relative modal-body">
        <div class="vm--top-left-slot">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0 pl-3">
              <i class="fas fa-lg fa-prescription mr-2"></i>Prescription
            </h3>
            <button class="btn p-2 border-0" @click="closePrescriptionModal">
              <i class="fas fa-times fa-lg"></i>
            </button>
          </div>
        </div>
        <div class="body-content modal-body-container" v-if="selectedNote">
          <prescription-item
            :prescriptionId="selectedNote.prescription_id"
            :engagementId="selectedNote.id"
            :hideControls="selectedNote.hideControls"
            @save="prescriptionSaved()"
            @delete="prescriptionSaved()"
            @cancel="closePrescriptionModal()"
          ></prescription-item>
        </div>
      </div>
    </modal>

    <modal
      class="encounter-modal"
      name="encounter-modal"
      transition="pop-out"
      :width="700"
      v-model="showEncounterModal"
    >
      <div class="position-relative modal-body">
        <div class="vm--top-left-slot">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              border-bottom
            "
          >
            <h3 class="mb-0 pl-3">
              <i class="fas fa-lg fa-info mr-2"></i>OneChart AI Info
            </h3>
            <button class="btn p-2 border-0" @click="closeEncounterModal">
              <i class="fas fa-times fa-lg"></i>
            </button>
          </div>
        </div>
        <div
          class="body-content modal-body-container pt-4"
          v-if="selectedEncounterNote"
        >
          <One-chart-info
            :note="selectedEncounterNote"
            @save="EncounterUpdated()"
            @cancel="closeEncounterModal()"
          ></One-chart-info>
        </div>
      </div>
    </modal>
    <adjust-session-time-modal
      ref="adjustTimeModal"
      @saved="onSessionTimeAdjusted"
    />
  </div>
</template>

<script>
import AudioRecorder from "@/components/AudioRecorder.vue";
import OneChartInfo from "@/components/OneChartInfo.vue";
import { EventBus } from "@/event-bus";
import * as dayjs from "dayjs";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import { richTextConfig } from "../../../tasks/RichTextConfig";
import TreeNode from "../intakeForms/TreeNode.vue";
import PrescriptionItem from "./components/Prescription.vue";
import AdjustSessionTimeModal from "@/components/AdjustSessionTimeModal.vue";
import { getAdjustTimeStatus as getAdjustTimeStatusUtil } from "@/utils/adjustSessionTime";

export default {
  name: "EngagementNotesList",
  components: {
    Multiselect,
    TreeNode,
    PrescriptionItem,
    AudioRecorder,
    OneChartInfo,
    AdjustSessionTimeModal,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    newOnly: {
      type: Boolean,
      default: false,
    },
    meeting: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showEncounterModal: false,
      showPrescriptionModal: false,
      showIntakeImageViewerModal: false,
      selectedIntakeImage: {
        name: "Generated Visual",
        type: "image",
        link: "",
      },
      loading: false,
      notes: [],
      gettingMeetingInfo: false,
      patientApts: [],
      isGettingAPts: false,
      patientGroupSessions: [],
      isGettingGroupSessions: false,
      gettingLastIntake: false,
      lastIntake: null,
      editor: richTextConfig.classicEditor,
      editorConfig: {
        placeholder:
          "Type your message or leave it empty to be automatically filled when using AI Scribe...",
        plugins: richTextConfig.plugins,
        ...richTextConfig.basicToolbar,
      },
      selectedStatus: null,
      statusOptions: [
        { label: "All", value: null },
        { label: "Certified", value: "approved" },
        { label: "In Review", value: "notApproved" },
      ],
      selectedICDCode: null,
      codeOptions: [
        { label: "All", value: null },
        { label: "With ICD codes", value: "1" },
        { label: "With no ICD codes", value: "2" },
      ],
      selectedNote: null,
      selectedEncounterNote: null,
      scribeStarted: false,
      scribeUploading: false,
      accessOptions: [
        { value: 1, label: "Admins Only" },
        { value: 0, label: "Shared with providers" },
      ],
    };
  },
  computed: {
    externalId: function () {
      return this.$route.query.id;
    },
    appointmentId: function () {
      return this.$route.query.apt;
    },
    ...mapState({
      user: (state) => state.auth.user || {},
      patient: (state) => state.patients.patient,
      ohipCodesLoading: (state) => state.HCAI.codes.loading,
      ohipCodes: (state) => state.HCAI.codes.data,
      notesInfo: (state) => state.oneai.oneChartNotesInfo,
      companyName: (state) => (state.settings.companyProfile || {}).name || "",
      publicSettings: (state) => state.settings.publicSettings?.data,
    }),
    scribeDemoLink: function () {
      if (this.meeting) {
        return "https://www.youtube.com/watch?v=Ek6LuZBbMdA";
      }
      return "https://www.youtube.com/watch?v=Ek6LuZBbMdA";
    },
    patientAptsOptions: function () {
      const events = [];

      this.patientApts
        .filter(
          (apt) =>
            this.user.isAdmin ||
            this.user.isManagingAdmin ||
            (this.user.isProvider && this.user.id == apt.user_1.id)
        )
        .forEach((apt) => {
          let label = "";
          let serviceName = "";
          if (apt.services.length) {
            serviceName = apt.services[0].name;
          }
          const subHourlyServices = apt.services.filter(
            (serv) => serv.parent_service_id && serv.pivot?.unit == "HR"
          );
          const subServicesHours = subHourlyServices.reduce(
            (sum, { pivot }) => sum + pivot?.quantity,
            0
          );
          const subMinutes =
            (subServicesHours - parseInt(subServicesHours)) * 60;
          label = dayjs(apt.start_time).utc().format("MMM D, YYYY hh:mm A");
          label = `${label} - ${dayjs(apt.end_time)
            .utc()
            .format("MMM D, YYYY hh:mm A")}`;
          if (serviceName) {
            label = `${label} (${serviceName})`;
          }
          if (subServicesHours) {
            label = `${label} +${parseInt(subServicesHours)}h${
              subMinutes > 0 ? " " + subMinutes + "m" : ""
            }`;
          }
          events.push({
            value: `apt-${apt.id}`,
            label,
            sortTime: apt.start_time,
          });
        });

      this.patientGroupSessions.forEach((gs) => {
        events.push({
          value: `gs-${gs.id}`,
          label: this.formatGroupSessionLabel(gs),
          sortTime: gs.start_time,
        });
      });

      // Backfill group sessions from notes that aren't in the fetched list
      const gsIds = new Set(this.patientGroupSessions.map((gs) => gs.id));
      (this.notes || []).forEach((note) => {
        if (note.group_session && !gsIds.has(note.group_session.id)) {
          gsIds.add(note.group_session.id);
          events.push({
            value: `gs-${note.group_session.id}`,
            label: this.formatGroupSessionLabel(note.group_session),
            sortTime: note.group_session.start_time,
          });
        }
      });

      events.sort((a, b) => new Date(b.sortTime) - new Date(a.sortTime));
      events.unshift({ value: null, label: "Select Event" });

      return events;
    },
    allPatientAptsOptions: function () {
      const events = [];

      this.patientApts.forEach((apt) => {
        let label = "";
        let serviceName = "";
        if (apt.services.length) {
          serviceName = apt.services[0].name;
        }
        const subHourlyServices = apt.services.filter(
          (serv) => serv.parent_service_id && serv.pivot?.unit == "HR"
        );
        const subServicesHours = subHourlyServices.reduce(
          (sum, { pivot }) => sum + pivot?.quantity,
          0
        );
        const subMinutes = (subServicesHours - parseInt(subServicesHours)) * 60;
        label = dayjs(apt.start_time).utc().format("MMM D, YYYY hh:mm A");
        label = `${label} - ${dayjs(apt.end_time)
          .utc()
          .format("MMM D, YYYY hh:mm A")}`;
        if (serviceName) {
          label = `${label} (${serviceName})`;
        }
        if (subServicesHours) {
          label = `${label} +${parseInt(subServicesHours)}h${
            subMinutes > 0 ? " " + subMinutes + "m" : ""
          }`;
        }
        events.push({
          value: `apt-${apt.id}`,
          label,
          sortTime: apt.start_time,
        });
      });

      this.patientGroupSessions.forEach((gs) => {
        events.push({
          value: `gs-${gs.id}`,
          label: this.formatGroupSessionLabel(gs),
          sortTime: gs.start_time,
        });
      });

      // Backfill group sessions from notes that aren't in the fetched list
      const gsIds = new Set(this.patientGroupSessions.map((gs) => gs.id));
      (this.notes || []).forEach((note) => {
        if (note.group_session && !gsIds.has(note.group_session.id)) {
          gsIds.add(note.group_session.id);
          events.push({
            value: `gs-${note.group_session.id}`,
            label: this.formatGroupSessionLabel(note.group_session),
            sortTime: note.group_session.start_time,
          });
        }
      });

      events.sort((a, b) => new Date(b.sortTime) - new Date(a.sortTime));

      return events;
    },
  },
  mounted() {
    this.listenToServerEvents();
    const aptsPromise = this.getPatientApt();
    this.getNotes().then((data) => {
      if (data && this.newOnly) {
        this.loading = true;
        aptsPromise.then(() => {
          this.addNewNote(this.meeting ? this.meeting.appointment.id : null);
          setTimeout(() => {
            this.loading = false;
          }, 0);
        });
      } else if (data && this.externalId) {
        if (this.externalId == "new") {
          aptsPromise.then(() => {
            this.addNewNote(this.appointmentId);
          });
        } else {
          setTimeout(() => {
            this.scrollToElement(`container-report-${this.externalId}`, 120);
          }, 100);
        }
      }
    });
    if (this.publicSettings?.GROUP_SESSIONS_ENABLED) {
      this.getPatientGroupSessions();
    }
    this.getHCAICodes();

    if (this.meeting) {
      this.gettingMeetingInfo = true;
      this.getPatientData({
        id: this.meeting.appointment.user_2.patient_id,
      }).then(() => {
        this.gettingMeetingInfo = false;
        this.getLastIntakeHelper();
      });
    } else {
      this.getLastIntakeHelper();
    }
    EventBus.$on("upload-scribe-complete", () => {
      this.getNotes(true);
    });
  },
  beforeDestroy() {
    EventBus.$off("upload-scribe-complete");
    window.Echo.leaveChannel(`onechart-documents-info`);
  },
  methods: {
    ...mapActions({
      getEngagementNotes: "patients/getEngagementNotes",
      addEngagementNote: "patients/addEngagementNote",
      editEngagementNote: "patients/editEngagementNote",
      deleteEngagementNote: "patients/deleteEngagementNote",
      toggleNoteAccessStatus: "patients/changeEngagementNoteAccess",
      generateReportSummary: "patients/generateEngagementSummary",
      getPatientData: "patients/get",
      getLastIntake: "intakeForms/getLastCompletedIntake",
      deleteEngagementNoteAttachment: "patients/deleteEngagementNoteAttachment",
      getHCAICodes: "HCAI/getCodes",
      approveEngagementNote: "patients/approveEngagementNote",
      addUpload: "uploads/addUpload",
      startUpload: "uploads/startUpload",
    }),
    openIntakeFormImage(img) {
      this.selectedIntakeImage = {
        name: "Generated Visual",
        type: "image",
        link: img.url,
      };
      this.showIntakeImageViewerModal = true;
    },
    deleteIntakeFormImage(note, img) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-black ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "This action is irreversible",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteEngagementNoteAttachment({
              userId: this.userId,
              noteId: note.id,
              attachmentId: img.id,
            }).then((success) => {
              if (success) {
                note.attachments = note.attachments.filter(
                  (attachment) => attachment.id !== img.id
                );
              }
            });
          }
        });
    },
    getSessionFromEventId(eventId) {
      if (!eventId) return null;
      if (typeof eventId === "string" && eventId.startsWith("gs-")) {
        const gsId = parseInt(eventId.replace("gs-", ""), 10);
        const gs = (this.patientGroupSessions || []).find((s) => s.id === gsId);
        return gs ? { ...gs, _type: "group" } : null;
      }
      if (typeof eventId === "string" && eventId.startsWith("apt-")) {
        const aptId = parseInt(eventId.replace("apt-", ""), 10);
        const apt = (this.patientApts || []).find((a) => a.id == aptId);
        return apt ? { ...apt, _type: "1:1" } : null;
      }
      return null;
    },
    getAdjustTimeStatus(note) {
      const session = this.getSessionFromEventId(note.event_id);
      return getAdjustTimeStatusUtil(session, this.user, this.publicSettings);
    },
    openAdjustTimeModal(note) {
      const session = this.getSessionFromEventId(note.event_id);
      if (!session) return;
      this.$refs.adjustTimeModal.show(session, session._type);
    },
    onSessionTimeAdjusted({ type, id, start_time, end_time }) {
      if (type === "1:1") {
        const idx = this.patientApts.findIndex((a) => a.id === id);
        if (idx !== -1) {
          this.$set(this.patientApts, idx, {
            ...this.patientApts[idx],
            start_time,
            end_time,
          });
        }
      } else if (type === "group") {
        const idx = this.patientGroupSessions.findIndex((s) => s.id === id);
        if (idx !== -1) {
          this.$set(this.patientGroupSessions, idx, {
            ...this.patientGroupSessions[idx],
            start_time,
            end_time,
          });
        }
      }
    },
    hasPermissionToEdit(note) {
      if (this.user.isAdmin || this.user.isManagingAdmin) {
        return true;
      }
      return (
        !note.approved &&
        (this.user.isAdmin ||
          this.user.isManagingAdmin ||
          this.user.id == note.reporter?.id)
      );
    },
    hasPermissionToDelete(note) {
      if (this.user.isAdmin || this.user.isManagingAdmin) {
        return true;
      }
      return (
        !note.approved &&
        (this.user.isAdmin ||
          this.user.isManagingAdmin ||
          this.user.id == note.reporter?.id)
      );
    },
    hasPermissionToApprove(note) {
      return (
        !note.approved &&
        (this.user.isAdmin ||
          this.user.isManagingAdmin ||
          this.user.id == note.reporter?.id)
      );
    },
    hasPermissionToReject(note) {
      return note.approved && (this.user.isAdmin || this.user.isManagingAdmin);
    },
    parseIntake(intake) {
      if (typeof intake === "string") {
        try {
          return JSON.parse(intake);
        } catch (_) {
          return intake;
        }
      }
      return intake;
    },
    getLastIntakeHelper() {
      this.gettingLastIntake = true;
      this.getLastIntake(this.userId).then((data) => {
        this.gettingLastIntake = false;
        if (data) {
          this.lastIntake = data;
          if (this.lastIntake.report) {
            if (this.patient.diagnosis) {
              this.lastIntake.report = {
                ...this.lastIntake.report,
                Diagnosis: this.patient.diagnosis,
              };
            }
            if (this.patient.assessment_active) {
              this.lastIntake.report = {
                ...this.lastIntake.report,
                Assessment: this.patient.assessment,
              };
            }
            if (this.patient.treatment_active) {
              this.lastIntake.report = {
                ...this.lastIntake.report,
                Treatment: this.patient.treatment,
              };
            }
            if (this.patient.intervention_active) {
              this.lastIntake.report = {
                ...this.lastIntake.report,
                Intervention: this.patient.intervention,
              };
            }
            this.notes
              .filter((note) => note.isNew)
              .forEach((note) => {
                note.intake_form = this.lastIntake;
                note.clientInfo = this.extractClientInfo(
                  JSON.stringify(this.lastIntake.report)
                );
              });
          }
        }
      });
    },
    getDocumentText(text) {
      let newText = text || "";
      newText = newText.replace(/\*\*(.*?)\*\*/g, (_, p1) => {
        return `<strong>${p1}</strong>`;
      });

      return newText
        .replace(/\n/g, "<br>")
        .replace(/(Speaker \d+:)/g, "<strong>$1</strong>");
    },
    getPatientApt: function () {
      this.isGettingAPts = true;
      return this.$http
        .get(`patients/${this.userId}/appointments?no_limit=true`)
        .then(
          (res) => {
            this.isGettingAPts = false;
            if (res && res.data && res.data.data) {
              this.patientApts = res.data.data;
            }
          },
          () => {
            this.isGettingAPts = false;
          }
        );
    },
    getPatientGroupSessions() {
      this.isGettingGroupSessions = true;
      this.$http.get(`patients/${this.userId}/group-sessions`).then(
        (res) => {
          this.isGettingGroupSessions = false;
          if (res && res.data && res.data.data) {
            this.patientGroupSessions = res.data.data;
          }
        },
        () => {
          this.isGettingGroupSessions = false;
        }
      );
    },
    formatGroupSessionLabel(gs) {
      if (!gs) return "Group Session";
      const start = dayjs(gs.start_time).utc().format("MMM D, YYYY hh:mm A");
      const end = dayjs(gs.end_time).utc().format("MMM D, YYYY hh:mm A");
      const programName = gs.program?.name || "Group Session";
      return `${start} - ${end} (${programName}) [Group]`;
    },
    onEventSelected(note, eventId) {
      if (!eventId) {
        this.$set(note, "appointment_id", null);
        this.$set(note, "group_session_id", null);
      } else if (eventId.startsWith("apt-")) {
        this.$set(
          note,
          "appointment_id",
          parseInt(eventId.replace("apt-", ""), 10)
        );
        this.$set(note, "group_session_id", null);
      } else if (eventId.startsWith("gs-")) {
        this.$set(
          note,
          "group_session_id",
          parseInt(eventId.replace("gs-", ""), 10)
        );
        this.$set(note, "appointment_id", null);
      }
    },
    getNotes: function (keepNew = false) {
      return new Promise((resolve) => {
        if (this.meeting) {
          return resolve([]);
        }
        if (!keepNew) {
          this.loading = true;
        }
        this.getEngagementNotes({
          userId: this.userId,
          status: this.selectedStatus,
          ohip: this.selectedICDCode,
        })
          .then((data) => {
            if (data) {
              data.forEach((note) => {
                note.appointment_id = note.appointment?.id || 0;
                note.group_session_id = note.group_session?.id || null;
                note.event_id = note.appointment?.id
                  ? `apt-${note.appointment.id}`
                  : note.group_session?.id
                  ? `gs-${note.group_session.id}`
                  : null;
                note.selectedCodes = note.service_codes;
              });
              const newNote = this.notes.find(
                (note) => note.isNew && note.id == "new"
              );

              const notes = this.newOnly
                ? []
                : (data || []).map((note) => {
                    return {
                      ...note,
                      ...(note.intake_form && {
                        clientInfo: this.extractClientInfo(note.intake_form),
                      }),
                      ...(note.intake_form && {
                        intake_form: this.processIntakeForm(note.intake_form),
                      }),
                    };
                  });
              if (keepNew && newNote) {
                this.notes = [newNote, ...notes];
              } else {
                this.notes = notes;
              }
            }
            this.loading = false;
            resolve(data);
          })
          .catch(() => {
            this.loading = false;
            resolve(null);
          });
      });
    },
    extractClientInfo: function (intakeReport) {
      const report = JSON.parse(intakeReport);
      if (!report) return {};
      if (report.name || report.Name) {
        return {
          name: report.name || report.Name,
          patient_id:
            report["Patient ID"] || report["PatientID"] || report["patient_id"],
          sex: report["Sex"] || report["sex"],
          dob: report["DOB"] || report["dob"],
          age: report["Age"] || report["age"],
          diagnosis: this.patient.diagnosis,
          ...(this.patient.assessment && {
            assessment: this.patient.assessment,
          }),
          ...(this.patient.treatment && { treatment: this.patient.treatment }),
          ...(this.patient.intervention && {
            intervention: this.patient.intervention,
          }),
        };
      }
      return {};
    },
    processIntakeForm: function (intakeReport) {
      const report = JSON.parse(intakeReport);
      const keysToRemove = [
        "name",
        "Name",
        "Patient ID",
        "PatientID",
        "patient_id",
        "Sex",
        "sex",
        "DOB",
        "dob",
        "Age",
        "age",
        "Diagnosis",
        "diagnosis",
        "Assessment",
        "assessment",
        "Treatment",
        "treatment",
        "Intervention",
        "intervention",
      ];

      keysToRemove.forEach((key) => {
        delete report[key];
      });
      return report;
    },
    getDate(formDate) {
      return dayjs(formDate).format("YYYY-MM-DD (hh:mm A)");
    },
    copyText(note, type = "") {
      let prefix = `report-`;
      let title = "The engagement note has been copied to your clipboard.";
      if (type == "narrative") {
        prefix = "narrative-";
        title = "The narrative summary has been copied to your clipboard.";
      } else if (type == "soap") {
        prefix = "soap-";
        title = "The SOAP note has been copied to your clipboard.";
      }
      navigator.clipboard
        .writeText(this.$refs[`${prefix}${note.id}`][0].innerText)
        .then(
          function () {
            Swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              icon: "success",
              title,
            });
          },
          function (err) {
            console.error("Async: Could not copy report: ", err);
          }
        );
    },
    addNewNote(appointmentId = null, groupSessionId = null) {
      if (this.notes && this.notes[0] && this.notes[0].isNew) {
        if (this.scribeUploading) {
          this.notes.shift();
          this.scribeUploading = false;
          this.$forceUpdate();
        } else {
          this.scrollToElement("container-report-new", 160);
          return;
        }
      }
      setTimeout(() => {
        this.notes.unshift({
          id: "new",
          isNew: true,
          access: 0,
          editingTitle: "Engagement Note",
          editingText: "",
          report: "",
          appointment_id: appointmentId,
          group_session_id: groupSessionId,
          event_id: appointmentId
            ? `apt-${appointmentId}`
            : groupSessionId
            ? `gs-${groupSessionId}`
            : null,
          selectedCodes: [],
          intake_form: this.lastIntake ? this.lastIntake : null,
          clientInfo:
            this.lastIntake && this.lastIntake.report
              ? this.extractClientInfo(JSON.stringify(this.lastIntake.report))
              : {},
        });
        this.$forceUpdate();
        setTimeout(() => {
          this.scrollToElement("container-report-new", 160);
        }, 100);
      }, 0);
    },
    editNote(note, cancel = false, type = "") {
      const htmlToRichHtml = (html) => {
        if (!html) {
          return "";
        }
        return String(html)
          .replace(/\n/gi, "<br data-cke-filler='true'>")
          .trim();
      };

      if (type == "narrative") {
        note.editingText = htmlToRichHtml(note.narrativeReport);
      } else if (type == "soap") {
        note.editingText = htmlToRichHtml(note.soapReport);
      } else {
        note.editingText = htmlToRichHtml(note.report);
      }
      note.editingTitle = note.title;
      note.selectedCodes = note.service_codes;
      note.appointment_id = note.appointment?.id;
      note.group_session_id = note.group_session?.id || null;
      note.event_id = note.appointment?.id
        ? `apt-${note.appointment.id}`
        : note.group_session?.id
        ? `gs-${note.group_session.id}`
        : null;
      note.editing = !cancel;
      if (cancel && note.isNew) {
        this.scribeStarted = false;
        this.notes.shift();
        this.$forceUpdate();
        this.$emit("engagementNoteDeleted", note);
        return;
      }
      this.$forceUpdate();
      setTimeout(() => {
        this.scrollToElement(
          cancel ? `container-report-${note.id}` : `edit-${note.id}`,
          120
        );
      }, 100);
    },
    deleteNote(note) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-black ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "This action is irreversible",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            note.deleting = true;
            this.$forceUpdate();
            this.deleteEngagementNote({
              userId: this.userId,
              id: note.id,
            }).then((success) => {
              note.deleting = false;
              this.$forceUpdate();
              if (success) {
                this.getNotes();
              }
            });
          }
        });
    },
    toggleNoteAccess(note) {
      const vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-black ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: `You are going to make this note accessable by ${
            note.access ? "all" : "admins only"
          }`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, make it ${
            note.access ? "public" : "private"
          }!`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            note.togglingAccess = true;
            vm.$forceUpdate();
            vm.toggleNoteAccessStatus({
              userId: vm.userId,
              id: note.id,
              access: !note.access,
            }).then((success) => {
              if (success) {
                note.access = !note.access;
              }
              note.togglingAccess = false;
              vm.$forceUpdate();
            });
          }
        });
    },
    approveNote(note) {
      const vm = this;
      let text = `Are you sure you want to certify the note?${
        this.user && this.user.isProvider
          ? " Once certified you will have to contact the admin to uncertify or edit"
          : ""
      }`;
      let buttonText = "Yes, certify";
      if (note.approved) {
        text = "Are you sure you want to uncertify the engagement note?";
        buttonText = "Yes, uncertify";
      }
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-black ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: buttonText,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            vm.approveNoteHelper(note);
          }
        });
    },
    approveNoteHelper(note) {
      note.approving = true;
      this.$forceUpdate();
      this.approveEngagementNote({
        userId: this.userId,
        id: note.id,
        approved: !note.approved,
      }).then((success) => {
        note.approving = false;
        this.$forceUpdate();
        if (success) {
          this.getNotes();
          Swal.fire({
            title: "Success",
            text: `Engagement note has been ${
              note.approved ? "un" : ""
            }certified successfully`,
            icon: "success",
          });
        }
      });
    },
    saveNote(note, approve = false) {
      let errorMessage = "";
      if (!note.editingTitle) {
        errorMessage = "Engagement note title can't be empty";
      } else if (!note.editingText) {
        errorMessage = "Engagement note message can't be empty";
      }

      if (errorMessage) {
        return Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
      note.saving = true;
      note.approving = approve;
      this.$forceUpdate();
      if (note.isNew) {
        const newNote = this.notes.find((n) => n.isNew);
        newNote.saving = true;
        newNote.approving = approve;
        this.addEngagementNote({
          userId: this.userId,
          title: note.editingTitle,
          report: note.editingText,
          approved: approve,
          access: note.access,
          appointment_id: note.appointment_id,
          group_session_id: note.group_session_id,
          service_codes: note.selectedCodes,
          meeting_id: note.meetingId,
          note_type: note.note_type,
          language: note.language,
        }).then((data) => {
          if (data) {
            this.notes.shift();
            this.notes.unshift({
              ...data,
              appointment_id: data.appointment?.id || 0,
              group_session_id: data.group_session?.id || null,
              event_id: data.appointment?.id
                ? `apt-${data.appointment.id}`
                : data.group_session?.id
                ? `gs-${data.group_session.id}`
                : null,
              selectedCodes: data.service_codes,
            });
            Swal.fire({
              title: "Success",
              text: `${
                note.meetingId && note.uploadType == "meeting"
                  ? "Engagement note has been submitted and in process"
                  : "Engagement note has been added successfully"
              }`,
              icon: "success",
            });
            this.$emit("engagementNoteAdded", data);
          } else {
            newNote.saving = false;
            newNote.approving = false;
          }
          this.$forceUpdate();
        });
      } else {
        this.editEngagementNote({
          id: note.id,
          userId: this.userId,
          title: note.editingTitle,
          report: note.editingText,
          approved: approve,
          appointment_id: note.appointment_id,
          group_session_id: note.group_session_id,
          service_codes: note.selectedCodes,
        }).then((data) => {
          if (data) {
            this.getNotes();
            Swal.fire({
              title: "Success",
              text: "Engagement note has been edited successfully",
              icon: "success",
            });
          } else {
            note.saving = false;
            note.approving = false;
          }
          this.$forceUpdate();
        });
      }
    },
    scrollToElement(id, offset) {
      const element = this.$refs[id][0];
      const top =
        element.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
    generateSummary(note, type) {
      if (type == "narrative") {
        note.narrativeLoading = true;
      } else if (type == "soap") {
        note.soapLoading = true;
      }
      this.$forceUpdate();
      this.generateReportSummary({ id: note.id, type }).then((summary) => {
        const result = (summary || "")
          .replace("```html", "")
          .replace("```", "");
        if (type == "narrative") {
          note.narrativeReport = result;
          note.narrativeLoading = false;
        } else if (type == "soap") {
          note.soapReport = result;
          note.soapLoading = false;
        }
        this.$forceUpdate();
      });
    },
    ownsNoteEvent(note) {
      if (note.appointment) {
        return this.patientAptsOptions.some(
          (item) => item.value === `apt-${note.appointment.id}`
        );
      }
      if (note.group_session) {
        return (note.group_session.providers || []).some(
          (p) => p.id === this.user.id
        );
      }
      return false;
    },
    canShowPrescription(note) {
      if (!note.appointment_id && !note.group_session_id) return false;
      if (this.user.isPatient) return !!note.prescription_id;
      if (this.user.isProvider && !note.prescription_id) {
        if (!this.ownsNoteEvent(note)) return false;
      }
      return true;
    },
    openPrescriptionModal(note) {
      this.selectedNote = JSON.parse(JSON.stringify(note));
      this.selectedNote.hideControls =
        this.user.isPatient ||
        (this.user.isProvider && !this.ownsNoteEvent(this.selectedNote));
      this.showPrescriptionModal = true;
    },
    closePrescriptionModal() {
      this.showPrescriptionModal = false;
      this.selectedNote = null;
    },
    prescriptionSaved() {
      this.showPrescriptionModal = false;
      this.getNotes();
    },
    openEncounterModal(note) {
      this.selectedEncounterNote = JSON.parse(JSON.stringify(note));
      this.showEncounterModal = true;
    },
    closeEncounterModal() {
      this.showEncounterModal = false;
      this.selectedEncounterNote = null;
    },
    EncounterUpdated() {
      this.showEncounterModal = false;
      this.getNotes();
    },
    updateScribeStatus() {
      this.scribeStarted = true;
    },
    async completeAIScribe(data, queuedCb) {
      const note = this.notes.find((n) => n.isNew);

      if (data.uploadType == "meeting" && data.meetingId) {
        return this.saveNote({
          ...note,
          editingText:
            note.editingText ||
            "The message will be added by OneChart after processing is complete.",
          meetingId: data.meetingId,
          note_type: data.note_type,
          language: data.language,
          uploadType: data.uploadType,
        });
      }
      let errorMessage = "";

      if (!note.editingTitle) {
        errorMessage = "Engagement note title can't be empty";
      } else if (!data.audioFile || data.audioFile.size === 0) {
        errorMessage = "Audio file can't be empty";
      }

      if (errorMessage) {
        return Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }

      // Prepare upload task data
      const sessionId = Date.now().toString();
      await this.addUpload({
        file: data.audioFile,
        userId: this.userId,
        sessionId,
        title: note.editingTitle,
        report:
          note.editingText ||
          "The message will be added by OneChart after processing is complete.",
        approved: false,
        appointment_id: note.appointment_id,
        group_session_id: note.group_session_id,
        service_codes: note.selectedCodes,
        fileName: data.audioFile.name,
        language: data.language,
        note_type: data.note_type,
        chunkSize: 10 * 1024 * 1024, // 10MB chunks
      });
      queuedCb();
      this.scribeUploading = true;
      this.startUpload(sessionId);
      this.$emit("engagementNoteAdded", data);
    },
    listenToServerEvents() {
      window.Echo.encryptedPrivate("onechart-documents-info").listen(
        "OneChartAiDocumentsInfo",
        (event) => {
          if (event.environment_name != this.companyName) return;
          if (event?.data?.id) {
            this.notes = this.notes.map((note) =>
              note.id == event.data.id ? { ...note, ...event.data } : note
            );
            this.$forceUpdate();
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.notes-list-container {
  .firsthx-image-thumb {
    position: relative;
    width: 140px;
    height: 140px;
    margin: 8px 8px 0 0;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #dcdcdc;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    .firsthx-image-delete-btn {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 22px;
      height: 22px;
      padding: 0;
      border: none;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      font-size: 11px;
      line-height: 22px;
      cursor: pointer;
    }
  }
  .select-100 {
    .select-outer-container {
      width: 100%;
    }
  }

  .adjust-time-link {
    position: absolute;
    top: -20px;
    right: 20px;
    z-index: 1;

    @media (max-width: 767px) {
      top: 0;
      right: 0;
    }
  }

  .expand-header {
    .expand-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: rotate(180deg) translateY(50%);
      transition: all 0.3s ease-in-out;
    }
    &.collapsed {
      .expand-icon {
        transform: rotate(90deg) translateX(-50%);
      }
    }
  }

  .approved-icon {
    position: absolute;
    top: 20px;
    span {
      font-size: 16px;
      letter-spacing: 2px;

      @media (max-width: 400px) {
        font-size: 12px;
      }
    }
  }
  .section-box {
    .title {
      background-color: rgba(37, 37, 37, 0.4);
      color: #ffffff;
      padding: 4px 8px;
    }
    .content {
      .item {
        margin-bottom: 4px;
      }
      .key {
        font-weight: bold;
        margin-right: 12px;
        text-transform: capitalize;
      }
    }
  }
  .note-container {
    border-top: 6px solid var(--secondary-color);
    padding: 4px 12px 12px 12px;
    background-color: #e9e4e482;
    position: relative;

    &.focused-note {
      animation: shadowBlink 1s 5;
      box-shadow: 0px 0px 2px 3px var(--theme-color);
      border: 1px solid #656565;
    }

    .report-outer-container {
      h2,
      h3 {
        text-decoration: underline;
        margin-top: 12px;
      }
      p {
        margin-bottom: 0;
      }
    }
  }
  .copy-btn {
    &:hover {
      color: #1657af !important;
    }
  }
  .ck-editor__editable_inline {
    min-height: 80px;
    max-height: 50vh;
  }

  .ck-editor__main {
    cursor: text;
  }

  .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
  .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .loader {
    top: 0;
    left: 0;
    right: 0;
    border: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.7);
    color: whitesmoke;
    flex-direction: column;
  }
}

@keyframes shadowBlink {
  0% {
    box-shadow: 0px 0px 6px 3px var(--theme-color);
  }
  50% {
    box-shadow: 0px 0px 6px 6px var(--theme-color);
  }
  100% {
    box-shadow: 0px 0px 6px 3px var(--theme-color);
  }
}

.prescription-modal,
.encounter-modal {
  .v--modal {
    height: 90vh !important;
    top: 5vh !important;
    background-color: #ffffff;
  }

  .modal-body-container {
    padding-bottom: 42px;
    padding-right: 8px;

    .prescription-componenet-container,
    .onechart-info-container {
      .actions {
        position: absolute;
        bottom: 0;
        left: 24px;
        right: 24px;
        background: white;
        z-index: 1;

        @media (max-width: 420px) {
          .btn {
            padding: 0.125rem 0.5rem;
            font-size: 0.8125000003rem;
            line-height: 1.75;
            border-radius: 0.25rem;
          }
        }
      }
    }
  }
}
</style>
